import { state } from '../state.js';
import { renderChildReport, resetReportPanel } from './report.js';

export const renderChildrenList = (groupId) => {
    const container = document.getElementById('childrenList');
    if (!container) return;

    const group = state.getGroupFromLevel(groupId);
    if (!group || !group.children) return;

    resetReportPanel();
    container.innerHTML = '';

    group.children.forEach(({ id, years }) => {
        const child = state.getChild(id);
        if (!child) return;

        const card = document.createElement('div');
        card.className = 'child-card';
        card.innerHTML = `
            <div class="child-avatar">
                ${child.photo_url
                    ? `<img src="${child.photo_url}" alt="${child.first_name} ${child.last_name}">`
                    : '<i class="bi bi-person-circle"></i>'}
            </div>
            <div class="child-info">
                <span class="child-name">${child.first_name} ${child.last_name}</span>
                <span class="child-years">Year ${years} in this level</span>
            </div>
        `;
        card.addEventListener('click', () => renderChildReport(id));
        container.appendChild(card);
    });
};
